import React from 'react';

const Footer = () => {
  return (
    <div
      style={{
        backgroundColor: 'white',
        padding: '12px',
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        borderTop: '1px solid #ccc',
        zIndex: 50,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px'
      }}
    >
      <img
        src="/qrfulldisclosure.png"
        alt="Full Disclosure QR Code"
        style={{
          width: '60px',
          height: '60px',
          userSelect: 'none',
          pointerEvents: 'none'
        }}
        draggable={false}
      />
      <span style={{ color: '#2563eb' }}>
        SCAN QR CODE TO DOWNLOAD THE FULL DISCLOSURE PDF FILES
      </span>
    </div>
  );
};

export default Footer;
